/** Workflows P5-4: kung paano iniwan ang isang hakbang (pagsusuri ng path) at ang "gayahin ang sagot ng assistant" sa Preview. Isinasama sa `engage.workflows.analysis` at `engage.workflows.builder.preview`. */
export const workflowsOutcomes = {
  analysis: {
    outcomesTitle: "Paano umalis ang mga bisita sa hakbang na ito",
    startOver: "Magsimula ulit",
    outcomes: {
      answered: "Nasagot",
      could_not_answer: "Hindi nasagot",
      asked_for_person: "Humiling ng tao",
      done: "Natapos",
      not_done: "Hindi natapos",
      received: "Natanggap ang tawag",
      timed_out: "Naubusan ng oras",
      replied: "Sumagot",
      no_reply: "Walang sagot sa oras",
      invalid: "Hindi tinanggap ang sagot",
      woke: "Nagising sa oras",
      interrupted: "Naputol",
      skipped: "Nilaktawan",
      success: "Nagtagumpay",
      failure: "Pumalya",
    },
  },
  preview: {
    outcome: {
      title: "Gayahin kung paano napupunta ang sagot ng assistant",
      hint: "Naghihintay ang run sa assistant. Piliin kung paano napunta ang sagot nito para sundan ang exit na iyon, o mag-type na lang ng tanong para sagutin ito ng assistant.",
      answered: "Nasagot",
      could_not_answer: "Hindi nasagot",
      asked_for_person: "Humiling ng tao",
      applied: "Ginaya: {{outcome}}. Nagpatuloy ang workflow.",
      failedTitle: "Hindi iyon gumana",
      failedBody: "Maaaring nagpatuloy na ang preview. I-restart ito para subukan ulit.",
    },
  },
};
